import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Dashboard from './pages/admin/Dashboard';
import SolicitudesList from './pages/admin/SolicitudesList';
import SolicitudDetalle from './pages/admin/SolicitudDetalle';
import JugadoresList from './pages/admin/JugadoresList';
import JugadorDetalle from './pages/admin/JugadorDetalle';
import RepresentantesList from './pages/admin/RepresentantesList';
import RepresentanteDetalle from './pages/admin/RepresentanteDetalle';
import PagosList from './pages/admin/PagosList';
import PagoDetalle from './pages/admin/PagoDetalle';
import ConceptosPago from './pages/admin/ConceptosPago';
import RepresentanteDashboard from './pages/representante/RepresentanteDashboard';
import InscripcionPublica from './pages/public/InscripcionPublica';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Rutas públicas */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/inscripcion" element={<InscripcionPublica />} />

          {/* Rutas protegidas - Admin */}
          <Route path="/admin" element={
            <ProtectedRoute adminOnly>
              <Layout><Dashboard /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/solicitudes" element={
            <ProtectedRoute adminOnly>
              <Layout><SolicitudesList /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/solicitudes/:id" element={
            <ProtectedRoute adminOnly>
              <Layout><SolicitudDetalle /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/jugadores" element={
            <ProtectedRoute adminOnly>
              <Layout><JugadoresList /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/jugadores/:id" element={
            <ProtectedRoute adminOnly>
              <Layout><JugadorDetalle /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/representantes" element={
            <ProtectedRoute adminOnly>
              <Layout><RepresentantesList /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/representantes/:id" element={
            <ProtectedRoute adminOnly>
              <Layout><RepresentanteDetalle /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/pagos" element={
            <ProtectedRoute adminOnly>
              <Layout><PagosList /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/pagos/:id" element={
            <ProtectedRoute adminOnly>
              <Layout><PagoDetalle /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin/conceptos-pago" element={
            <ProtectedRoute adminOnly>
              <Layout><ConceptosPago /></Layout>
            </ProtectedRoute>
          } />

          {/* Rutas protegidas - Representante */}
          <Route path="/representante" element={
            <ProtectedRoute>
              <RepresentanteDashboard />
            </ProtectedRoute>
          } />

          {/* Redirección por defecto */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
